import { PriceType, SalesTax, SetupFee, createPriceType, createSalesTax, createSetupFee } from '../models/market.model';
import { PriceDisplayOption, createPriceDisplayOption as createPriceDisplayOption } from '../models/price.model';

export const RRR: number[] = [
  // Base RRR values
  0.0, 0.13, 0.153, 0.286, 0.367, 0.248,

  // With Focus
  0.371, 0.425, 0.435, 0.497, 0.539, 0.479,

  // With daily bonus 10%
  0.091, 0.2, 0.219, 0.333, 0.405, 0.301,

  // With daily bonus 20%
  0.167, 0.259, 0.275, 0.375, 0.438, 0.346,

  // With daily bonus & Focus 10%
  0.408, 0.457, 0.465, 0.522, 0.559, 0.505,

  // With daily bonus & Focus 20%
  0.441, 0.485, 0.492, 0.543, 0.578, 0.528,
].sort((a, b) => a - b);

export const SETUP_FEES = {
  normal: createSetupFee('Normal/Premium', 0.025),
};
export const SMUGGLER_FEE = 0.04;
export function getAllSetupFees(): SetupFee[] {
  return Object.values(SETUP_FEES);
}
export function getSetupFeeByName(name: string): SetupFee {
  const setupFee = getAllSetupFees().find((fee) => fee.name === name);
  if (!setupFee) {
    throw new Error(`Setup Fee with name ${name} not found.`);
  }
  return setupFee;
}
export const SALES_TAXES = {
  normal: createSalesTax('Normal', 0.08),
  premium: createSalesTax('Premium', 0.04),
};
export function getAllSalesTaxes(): SalesTax[] {
  return Object.values(SALES_TAXES);
}
export function getSalesTaxByName(name: string): SalesTax {
  const salesTax = getAllSalesTaxes().find((tax) => tax.name === name);
  if (!salesTax) {
    throw new Error(`Sales Tax with name ${name} not found.`);
  }
  return salesTax;
}
export const PRICE_TYPES = {
  buy: createPriceType('Buy', 'Buy Order'),
  sell: createPriceType('Sell', 'Sell Order'),
  average: createPriceType('Average', 'Average Price'),
};
export function getAllPriceTypes(): PriceType[] {
  return Object.values(PRICE_TYPES);
}
export function getPriceTypeByName(name: string): PriceType {
  const priceType = getAllPriceTypes().find((type) => type.name === name);
  if (!priceType) {
    throw new Error(`Price Type with name ${name} not found.`);
  }
  return priceType;
}
export const FAME_BONUS_PREMIUM: number = 0.5;
export const PRICE_DISPLAY_OPTIONS = {
  single: createPriceDisplayOption(0, 'Single'),
  tier: createPriceDisplayOption(1, 'Tier'),
  all: createPriceDisplayOption(2, 'All'),
};
export function getAllPriceDisplayOptions(): PriceDisplayOption[] {
  return Object.values(PRICE_DISPLAY_OPTIONS);
}
export function getPriceDisplayOptionById(id: number): PriceDisplayOption {
  const priceDisplayOption = getAllPriceDisplayOptions().find((option) => option.id === id);
  if (!priceDisplayOption) {
    throw new Error(`Price Display Option with id ${id} not found.`);
  }
  return priceDisplayOption;
}
